import { useMeta } from '@interhyp/platform-meta';
import { useEffect } from 'react';

/*
`app-interhyp-home` and `@interhyp/platform-meta` store the stage metadata in a different variable and in a different format.
This hook translates the new format into the old format in order to keep the modules working
 */
export const useEnvBridge = (): void => {
  const meta = useMeta();

  useEffect(() => {
    switch (meta.stage) {
      case 'dev':
        window.process.env.APP_ENV = 'test';
        break;
      case 'acc':
        window.process.env.APP_ENV = 'livetest';
        break;
      default:
        window.process.env.APP_ENV = 'prod';
    }
  }, [meta.stage]);
};
